import { useState, useEffect } from "react";
import "@/App.css";
import { translations } from "@/i18n";
import { applyLangSeo } from "@/lib/seo";
import { useReveal } from "@/hooks/use-reveal";
import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Services from "@/components/sections/Services";
import About from "@/components/sections/About";
import Process from "@/components/sections/Process";
import VideoShowcase from "@/components/sections/VideoShowcase";
import ImportantNotice from "@/components/sections/ImportantNotice";
import PriceCalculator from "@/components/sections/PriceCalculator";
import Faq from "@/components/sections/Faq";
import BookingSection from "@/components/sections/BookingSection";
import ReviewsStrip from "@/components/sections/ReviewsStrip";
import ReviewCTA from "@/components/sections/ReviewCTA";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import WhatsAppButton from "@/components/sections/WhatsAppButton";

function readStoredLang() {
  if (typeof window === "undefined") return "hu";
  const stored = window.localStorage.getItem("att_lang");
  if (stored === "en" || stored === "de" || stored === "nl") return stored;
  return "hu";
}

function App() {
  const [lang, setLang] = useState(readStoredLang);
  const [calcPrefill, setCalcPrefill] = useState(null);
  const t = translations[lang];
  const wrapRef = useReveal();

  useEffect(() => {
    window.localStorage.setItem("att_lang", lang);
    document.documentElement.lang = lang;
    applyLangSeo(lang);
  }, [lang, applyLangSeo]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="App" ref={wrapRef} data-testid="app-root">
      <Header t={t} lang={lang} setLang={setLang} scrollTo={scrollTo} />
      <Hero t={t} scrollTo={scrollTo} />
      <Marquee t={t} />
      <Services t={t} />
      <About t={t} />
      <Process t={t} />
      <VideoShowcase t={t} />
      <ImportantNotice t={t} />
      <PriceCalculator t={t} lang={lang} scrollTo={scrollTo} onPrefill={setCalcPrefill} />
      <BookingSection t={t} lang={lang} prefill={calcPrefill} />
      <Faq t={t} />
      <ReviewsStrip t={t} lang={lang} />
      <ReviewCTA t={t} />
      <Contact t={t} />
      <Footer t={t} />
      <WhatsAppButton t={t} />
    </div>
  );
}

export default App;
